export default __webpack_public_path__ + "static/media/groundplan_s_84b.ca44e3b2.png";